import dayjs, { type ConfigType } from "dayjs";
import "dayjs/locale/ru.js";
import type { PaymentMethod, TicketDateOption } from "@/types";

const weekdays = ["ВС", "ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ"];

export function createDateOptions(
  startDate: ConfigType = dayjs(),
  daysAhead = 10,
  pricesByDate: Record<string, number> = {},
): TicketDateOption[] {
  const start = dayjs(startDate).locale("ru").startOf("day");
  const end = start.add(daysAhead, "day");
  const dates: TicketDateOption[] = [];

  for (
    let current = start;
    current.isBefore(end, "day") || current.isSame(end, "day");
    current = current.add(1, "day")
  ) {
    const weekday = current.day();
    const dateId = current.format("YYYY-MM-DD");

    dates.push({
      id: dateId,
      month: capitalize(current.format("MMMM")),
      weekday: weekdays[weekday],
      day: current.format("D"),
      label: current.format("D MMMM"),
      displayDate: current.format("DD.MM.YYYY"),
      price: pricesByDate[dateId] ?? null,
      isWeekend: weekday === 0 || weekday === 6,
    });
  }

  return dates;
}

function capitalize(value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export const paymentMethods: PaymentMethod[] = [
  {
    id: "bank_card",
    title: "Банковская карта",
    icon: "#ticket-widget-icon-card",
    style: "min-w-6 h-6 w-6 lg:min-w-10 lg:h-10 lg:w-10 stroke-ink",
  },
  {
    id: "sbp",
    title: "СБП",
    icon: "#ticket-widget-icon-sbp",
    style: "min-w-12 h-6 w-12 lg:min-w-20 lg:h-10 lg:w-20",
  },
];
